export const isIosDevice = (): boolean => {
    if (typeof navigator === "undefined" || !navigator.userAgent) {
        return false;
    }

    return /iPad|iPhone|iPod/.test(navigator.userAgent);
};
